import MatchDetailsTeamA from "./MatchDetailsTeamA.jsx"
import MatchDetailsTeamB from "./MatchDetailsTeamB.jsx"

export default function MatchStarted({ match }) {
  return (
    <div className="flex flex-row items-center justify-center space-x-4 pb-4">
      <MatchDetailsTeamA match={match} />

      <div className="flex px-1 items-center justify-center">
        <span className="font-bold mr-2 text-red-500">{match.team_a_score != null ? match.team_a_score : 0}</span>
        x
        <span className="font-bold ml-2 text-red-500">{match.team_b_score != null ? match.team_b_score : 0}</span>
      </div>

      <MatchDetailsTeamB match={match} />
    </div>
  )
}
